import {RichText, TextStyleParams} from '@gongxigames/framework/core/fragments/display';

const buyFeatureButtonStyle: TextStyleParams = {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 65,
    fontStyle: 'normal',
    fill: '#ffffff',
    align: 'center'
};

RichText.setStyle('BuyFeatureButtonStyle', {
    verticalAlign: 'center',
    ...buyFeatureButtonStyle
});

RichText.setStyle('BuyFeaturePriceStyle', {
    ...buyFeatureButtonStyle,
    verticalAlign: 'center',
    fontSize: 80,
    fontWeight: 'bold'
});

RichText.setStyle('BuyFeaturePopupButtonStyle', {
    ...buyFeatureButtonStyle,
    fontSize: 160,
    verticalAlign: 'center'
});

RichText.setStyle('BuyFeaturePopupTextStyle', {
    ...buyFeatureButtonStyle,
    verticalAlign: 'center',
    textTransform: 'uppercase',
    lineHeight: 240,
    fontSize: 120
});
